import { ResourceName, PartnerStatus } from "@/types";
import { getInputProps } from "@/utils/helpers/columnsHelper";
import { Box, Stack } from "@mui/material";
import { TextInput, SelectInput } from "react-admin";

const getPartnerInputProps = (key: string, textReplace = {}) => getInputProps(key, textReplace, ResourceName.PARTNERS);

export const PartnerCreateInputs = () => {
  return (
    <Box p={2}>
      {/* Partner Information */}
      <Stack direction="row" spacing={1}>
        <TextInput {...getPartnerInputProps("partner_company_name")} required fullWidth size="small" />
        <TextInput
          {...getPartnerInputProps("partner_code")}
          required
          fullWidth
          size="small"
          inputProps={{ maxLength: 4 }}
        />
      </Stack>

      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        <TextInput {...getPartnerInputProps("domain")} required fullWidth size="small" />
        <TextInput {...getPartnerInputProps("accel_product_name")} fullWidth size="small" />
      </Stack>

      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        <SelectInput
          {...getPartnerInputProps("status")}
          choices={[
            { id: PartnerStatus.PENDING, name: "Pending" },
            { id: PartnerStatus.ACTIVE, name: "Active" },
            { id: PartnerStatus.SUSPENDED, name: "Suspended" },
            { id: PartnerStatus.TERMINATED, name: "Terminated" },
          ]}
          defaultValue={PartnerStatus.PENDING}
          fullWidth
          size="small"
        />
        <TextInput {...getPartnerInputProps("logo_image")} fullWidth size="small" />
      </Stack>
    </Box>
  );
};
